import { contactApiUrl } from "./contactApiUrl";

/** Shown in the UI on any failure. Details are only logged to the console for admins. */
export const CONTACT_FORM_PUBLIC_ERROR =
  "Something went wrong. Please try again in a moment, or email sales@deskreplay.com.";

/**
 * POST marketing contact/demo payloads to the configured contact API.
 * Always returns a generic user-visible message on failure; technical detail goes to console.error only.
 */
export async function postContactApi(
  payload: Record<string, unknown>,
): Promise<{ ok: boolean; error?: string }> {
  const url = contactApiUrl();
  let res: Response;
  try {
    res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (e) {
    console.error("[contact] fetch failed:", url, e);
    return { ok: false, error: CONTACT_FORM_PUBLIC_ERROR };
  }

  const text = await res.text();
  let parsed: { ok?: boolean; error?: string } = {};
  try {
    parsed = JSON.parse(text) as typeof parsed;
  } catch {
    /* non-JSON body */
  }

  if (!res.ok) {
    console.error("[contact] non-OK response:", {
      status: res.status,
      url,
      bodyPreview: text.slice(0, 800),
      parsed,
    });
    return { ok: false, error: CONTACT_FORM_PUBLIC_ERROR };
  }

  return { ok: true };
}
